module.exports = __webpack_public_path__ + "assets/dashboard-active.9316bd84.svg";